import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { hasPhotoLikeComponent, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

export interface IRefreshButton {
  rootStore?: RootStore;
}

export const getActiveCustomTabScope = () => {
  const scope = (window as any).__activeCustomTabScope;
  if (!scope || typeof scope.cid === 'undefined' || typeof scope.index === 'undefined') {
    return null;
  }

  const panel = document.querySelector(
    `.custom-tab-panel[data-tab-cid="${scope.cid}"][data-tab-index="${scope.index}"]`
  ) as HTMLElement | null;

  if (!panel) {
    return null;
  }

  const style = window.getComputedStyle(panel);
  if (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    style.opacity === '0'
  ) {
    return null;
  }

  return {
    cid: String(scope.cid),
    index: Number(scope.index),
  };
};

export  const dispatchSetIsEndFalse = () => {
  const event = new Event('set-is-end-false') as any;
  const scope = getActiveCustomTabScope();
  if (scope) {
    event.cid = scope.cid;
    event.index = scope.index;
    event.tabCid = scope.cid;
    event.tabIndex = scope.index;
  }
  window.dispatchEvent(event);
};

const RefreshButton = (props: IRefreshButton) => {
  const { rootStore } = props;
  const { uiStore } = rootStore!;
  const activeGallery = activeGalleryInstance.get();
  const morePhoto = activeGallery ? activeGallery.morePhoto : 0;

  const [hideTip, setHideTip] = useState(true);
  useEffect(() => {
    if (morePhoto * 1 > 0) {
      setHideTip(false);
    }
    const timer = setTimeout(() => setHideTip(true), 5000);
    return () => clearTimeout(timer);
  }, [morePhoto]);

  const [iconActive, setIconActive] = useState(false);
  const iconClick = function() {
    setTimeout(() => {
      setIconActive(false);
    }, 1000);
    setIconActive(true);

    toTop();

    let oldTotal = activeGallery ? activeGallery.total : 0;

    if (!activeGallery) return;
    // @ts-ignore
    activeGallery.reload && activeGallery.reload({ notmerge: true }).then((res: any) => {
      dispatchSetIsEndFalse();
      // 发现, 如果是原来就是空的, 就会没任何提示, 这儿做一下处理, 就是本身是空列表, 刷新也有反馈
      if (res && typeof res.total === 'number') {
        if (oldTotal >= res.total) {
          uiStore.showToast({ content: intl.get('NoMorePhoto') });
        } else {
          uiStore.showToast({
            content: intl.get('MorePhoto', {
              num: res.total - oldTotal
            })
          });
        }
      }
    });

    stat.event('button_refresh');
  };

  const iconCls = classNames('icon-refresh', { active: iconActive });
  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [visible, setVisible] = useState(false);

  const canShowGalleryButtons = () => {
    // 检测一下当前是否有对应的组件之类的
    let { data, video_data } = window.pageDetail;
    // 这儿是老逻辑, 只判断相册, 如果是新增加的空白页面, 那么走到下一个if去
    if (data) {
      return hasPhotoLikeComponent(window.pageDetail.template || []);
    }

    // 如果有tagphoto组件, 也展示刷新按钮
    if(hasPhotoLikeComponent(window.pageDetail.template || [])) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    // 初始检测
    setVisible(canShowGalleryButtons());

    const notifyButtonsChange = (e: any) => {
      let action = (e.action || '') as string;
      if (action == 'tab_no_photo') {
        setVisible(false);
      }
      if (action == 'tab_has_photo') {
        setVisible(true);
      }
    };

    window.addEventListener('PENDENT_CHANGE', notifyButtonsChange);

    return () => {
      window.removeEventListener('PENDENT_CHANGE', notifyButtonsChange);
    };
  }, []);

  console.log('refresh visible', visible);
  return (
    <NormalButton className={`pendant-refresh ` + (!visible && 'hide')}>
      <>
        <span className={iconCls} onClick={iconClick} />
        {morePhoto * 1 > 0 ? (
          <div className="pendant-badge">{Math.min(morePhoto, 99)}</div>
        ) : null}
      </>
    </NormalButton>
  );
};

export default inject('rootStore')(observer(RefreshButton));
